import React from 'react';
import { useLocation } from 'react-router-dom';

import { Box, Typography } from '@mui/material';
import { IS_SANDBOX_ENV, SANDBOX_BANNER_TEXT } from 'helper/constant';

import styles from './styles.module.css';

const SandboxBanner = () => {
    const location = useLocation();

    // Only show the banner in the sandbox environment
    if (!IS_SANDBOX_ENV) return null;

    let textType = 'DEFAULT';

    // Match /users/<uuid> route to show user profile banner
    const uuidRegex = /^\/users\/[0-9a-fA-F-]{36}$/;
    if (uuidRegex.test(location.pathname)) {
        textType = 'USER_PROFILE';
    } else if (location.pathname === '/integrations') {
        textType = 'INTEGRATION';
    }

    return (
        <Box className={styles.bannerContainer}>
            <Typography className={styles.bannerText}>{SANDBOX_BANNER_TEXT[textType]}</Typography>
        </Box>
    );
};

export default SandboxBanner;
